// components
import tournament from "@tournaments";
import DocumentsPage from "@components/DocumentsPage";

const Dian = () => (
  <DocumentsPage title="Información DIAN" documents={tournament.dianDocuments} />
);

export default Dian;
